module.exports = __webpack_public_path__ + "static/media/world.a7580d77.png";